module.exports = __webpack_public_path__ + "img/graduate-cap-1.2b4751d2.svg";